






























































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { MswApiService } from '../msw-api-service';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Country, State } from  './types';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { StateList } from './../statesList';
import { required , maxLength, helpers } from 'vuelidate/lib/validators';
import RegexValidators from '@/shared/regex-validators';
import { DEFAULT_TEXTFIELD_WIDTH } from '../../modules/msw-checkout/constants/checkout-constants';
import _ from 'lodash';
const addressCheck = helpers.regex('addressCheck', new RegExp(RegexValidators.address));
const cssPrefix = 'countryStateComponent';
@Component({
  components: {
    SwSelect,
    SwTextfield,
  },
  validations: {
    selectedCountryValue:{ required },
    selectedStateValue: { required },
    selectedProvinceValue: { required, addressCheck, maxLength: maxLength(50) },
  },
})
export default class CountryStateComponent extends SwExtendedVue {

  @Prop()
  initialCountryValue : string;
  @Prop()
  initialStateValue: string;
  @Prop()
  initialProvince: string;
  @Prop()
  widthConfig: any;

  @Prop({ required: false })
  fieldWidth: string;

  @Prop({ required: false, default: false })
  isDisableCountryState: boolean;

  @Watch('isDisableCountryState')
  private onChangeState() {
    this.disableForm = this.isDisableCountryState ? true : false;
  }

  hasStates: boolean = false;
  disableForm: boolean = false;
  cssPrefix = cssPrefix;
  countries: Country[] = [];
  states: State[] = [];

  selectedCountryValue: any = '';
  selectedStateValue: any =  '';
  selectedProvinceValue: any = '';
  textfiledWidth: string = '';
  created() {
    this.getCountries();
  }
  mounted() {
    this.disableForm = this.isDisableCountryState ? true : false;
    this.textfiledWidth = this.fieldWidth ? this.fieldWidth : DEFAULT_TEXTFIELD_WIDTH;
  }
  getCountries() {
    this.$store.commit('startLoading');
    MswApiService.getCountries.getCountriesFromServer()
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.msgCode === 'MSWAPP:SUCCESS') {
          this.countries = res.content.hasOwnProperty('lstCountries') ?  res.content.lstCountries : [];
          this.selectedCountryValue = this.initialCountryValue ?
          this.countries.filter((country: Country) => { return country.countryCode === this.initialCountryValue; })[0].countryCode :
          this.countries[0].countryCode;
          this.onChangeCountryValue(this.selectedCountryValue);
          if (this.selectedCountryValue === 'US' || this.selectedCountryValue === 'CA') {
            this.hasStates = true;
            this.states = this.selectedCountryValue === 'US' ? [...StateList.US] :
            this.selectedCountryValue === 'CA' ? [...StateList.CA] : [];
            this.selectedStateValue = this.initialStateValue ?
            this.states.filter((state : State) => { return state.stateCode === this.initialStateValue; })[0].stateCode :
            this.states[0].stateCode;
            this.onChangeStateValue(this.selectedStateValue);
          } else {
            this.hasStates = false;
            this.selectedProvinceValue = this.initialProvince ? this.initialProvince : '';
            this.onInputProvinceValue(this.selectedProvinceValue);
          }
        }
      })
      .catch((errResp: any) => {
        console.warn(errResp);
        this.$store.commit('stopLoading');
      });
  }
  get countriesOptions() : SelectOption[]  {
    const tempArr: SelectOption[] = [];
    this.countries.map((country: Country) => {
      tempArr.push({
        id: country.countryCode ? country.countryCode : '',
        value: country.countryCode ? country.countryCode : '',
        label: country.countryName ? country.countryName : '',
      });
    });
    return tempArr;
  }
  get statesOptions() : SelectOption[] {
    const tempArr: SelectOption[] = [];
    this.states = this.selectedCountryValue === 'US' ? [...StateList.US] :
       this.selectedCountryValue === 'CA' ? [...StateList.CA] : [];
    this.states && this.states.map((state: State) => {
      tempArr.push({
        id: state.stateCode ? state.stateCode : '',
        value: state.stateCode ? state.stateCode : '',
        label: state.stateName ? `${this.$t(state.stateName)}` : '',
      });
    });
    return tempArr;
  }
  onChangeCountryValue(country: any) {
    if (this.selectedCountryValue === 'US' || this.selectedCountryValue === 'CA') {
      this.hasStates = true;
      this.states = this.selectedCountryValue === 'US' ? [...StateList.US] :
      this.selectedCountryValue === 'CA' ? [...StateList.CA] : [];
      this.selectedStateValue = this.states[0] && this.states[0].stateCode;
    } else {
      this.hasStates = false;
    }
    if (country) {
      const isVatRequired = this.countries.filter((cotry: Country) => { return cotry.countryCode === country; })[0].isVatRequired ? true : false;
      const value = {
        country,
        isVatRequired,
        label: 'country',
        addressValidation: this.$v,
        hasStates: this.hasStates,
      };
      this.$emit('on-value-changes', value);
    }
  }
  onChangeStateValue(state: any) {
    if (state) {
      const value = {
        state,
        label: 'state',
        addressValidation: this.$v,
        hasStates: this.hasStates,
      };
      this.$emit('on-value-changes', value);
    }
  }
  onInputProvinceValue(province: any) {
    if (province) {
      const value = {
        province,
        label: 'province',
        addressValidation: this.$v,
        hasStates: this.hasStates,
      };
      _.debounce(
      () => {
        this.$emit('on-value-changes', value);
      },
      600,
      );
    }
  }

  isCountryStateValid() : any[] {
    // tslint:disable-next-line:max-line-length
    const isVatRequired = this.countries.filter((cotry: Country) => { return cotry.countryCode === this.selectedCountryValue; })[0].isVatRequired ? true : false;
    if (this.hasStates) {
      return [this.$v!.selectedCountryValue!.required &&
        this.$v!.selectedStateValue!.required, isVatRequired];
    }
    return [this.$v!.selectedCountryValue!.required &&
      this.$v!.selectedProvinceValue!.required, isVatRequired];
  }
  getWidth(value: string) {
    if (value === 'label') {
      return `${this.widthConfig.label}%`;
    }
    return `${this.widthConfig.field}%`;
  }
}
